import script from "./confirm_modal.vue?vue&type=script&setup=true&lang=js"
export * from "./confirm_modal.vue?vue&type=script&setup=true&lang=js"

import "./confirm_modal.vue?vue&type=style&index=0&id=67af95f9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67af95f9"]])

export default __exports__